<template>
	<div class="modal fade" id="validationModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
		<div class="modal-dialog">
			<div class="modal-content">
				<button type="button" style="display:none" class="btn-close" data-bs-dismiss="modal" id="validationModalCloseBTN"></button>
				<div class="modal-body p-3">
					<div class="col-md-12 ">
						<h4 class="agileinfo_sign" style="text-align:right;font-size:16px">لطفاً کد پیامک شده به شماره {{ props.userMobile }} را وارد نمایید</h4>
						<input class="form-control w-100 default-input my-2" type="tel" maxlength="4" minlength="4" v-model="inputCode" placeholder="-- -- -- --" />
						<span style="color:red">{{ validMessage }}</span>
						<button class="btn btn-primary valid-btn  my-2" id="submitBTN" @click="validCode">تایید</button>
						<button class="btn  valid-btn" style="color: rgb(143 77 77);" @click="correctNumber">کدرو نگرفتی؟ اصلاح شماره</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<sign-popup :suserMobile="userMobile" />
</template>

<script setup>
import SignPopup from './sign.vue'
import { reactive, ref, defineProps,watch,onMounted } from 'vue';
import { convertToEnglish, convertToPersian } from '@/composables/digits.js';
const props = defineProps(['code', 'userMobile']);
let inputCode = ref()
watch(inputCode,() => {
	inputCode.value = convertToPersian(inputCode.value)
	if(inputCode.value.length == 4){
		validCode()
	}
})
let finalCode = ref();
let validMessage = ref();
let key = ref();

function correctNumber() {
	document.querySelector('#validationModalCloseBTN').click();
	document.querySelector('#mobileModalBTN').click();
}
function validCode() {
	finalCode.value = convertToEnglish(inputCode.value);
	if (finalCode.value == props.code) {
		validMessage.value = '';
		document.querySelector('#signModalBTN').click();

	} else {
		validMessage.value = 'کد وارد شده صحیح نیست'
	}

}
</script>

<style scoped>
.dir-rtl {
	text-align: right;
	direction: rtl;
}

.input-code {
	direction: ltr !important;
}

.prtext-center {
	text-align: center;
}

.input-code>input {
	line-height: 2;
	border: 0;
	border-bottom: 2px solid #e1e1e1;
	border-radius: 0;
	text-align: center;
	margin: 0 3px;
	width: 40px;
	height: 40px;
	display: inline-block;
	vertical-align: baseline;
	padding: 0;
	font-size: 25px;
	outline: 0 !important;
}

.valid-btn {
	width: 100%;
	/* background: #36cddf; */
	border: none
}
.default-input{
    background: #fff;
    border: 1px solid #bebebe;
    box-sizing: border-box;
    border-radius: 21px!important;
    height: 50px;
    font-weight: 700;
    font-size: 20px;
	text-align: center !important;
	letter-spacing: 5px;
	border: 1px solid #dedeff !important;
    border-radius: 10px !important;
}
::placeholder {
   text-align: center; 
   letter-spacing: -2px;
   word-spacing: 5px;
}

</style>